(function () {
  function mod(n, m) {
    return ((n % m) + m) % m;
  }

  function initSlider(root) {
    if (!root || root.dataset.authorSliderInitialized === 'true') {
      return;
    }

    root.dataset.authorSliderInitialized = 'true';

    var slider = root.querySelector('[data-author-slider]');
    if (!slider) {
      return;
    }

    var items = Array.prototype.slice.call(slider.querySelectorAll('.author-item')).slice(0, 10);
    var prevBtn = root.querySelector('.author-prev');
    var nextBtn = root.querySelector('.author-next');
    var dotsWrap = root.querySelector('[data-author-dots]');
    var current = 0;
    var scrollSyncTimer = null;
    var suppressScrollSync = false;

    if (items.length === 0) {
      root.classList.remove('author-has-single-item');
      root.classList.remove('author-has-two-items');
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    root.style.setProperty('--author-item-count', String(items.length));
    root.classList.toggle('author-has-single-item', items.length === 1);
    root.classList.toggle('author-has-two-items', items.length === 2);
    root.classList.toggle('author-has-three-items', items.length === 3);
    root.classList.toggle('author-has-four-items', items.length === 4);
    root.classList.toggle('author-static-layout', items.length <= 4);

    if (items.length === 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (dotsWrap) dotsWrap.style.display = 'none';
    }

    function isMobileMode() {
      return window.innerWidth <= 768;
    }

    function syncButtons() {
      var hide = isMobileMode() || items.length <= 4;
      if (prevBtn) {
        prevBtn.style.display = hide ? 'none' : '';
      }
      if (nextBtn) {
        nextBtn.style.display = hide ? 'none' : '';
      }
    }

    function syncDots() {
      if (!dotsWrap) {
        return;
      }

      if (items.length <= 4) {
        dotsWrap.style.display = 'none';
        return;
      }

      Array.prototype.slice.call(dotsWrap.children).forEach(function (dot, index) {
        dot.classList.toggle('active', index === current);
      });
    }

    function getCenteredIndex() {
      var center = slider.scrollLeft + (slider.clientWidth / 2);
      var bestIndex = current;
      var bestDistance = Infinity;

      items.forEach(function (item, index) {
        var itemCenter = item.offsetLeft + (item.offsetWidth / 2);
        var distance = Math.abs(itemCenter - center);

        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    function scrollMobileToCurrent(animate) {
      var item = items[current];
      if (!item) {
        return;
      }

      suppressScrollSync = true;
      slider.scrollTo({
        left: Math.max(0, item.offsetLeft - ((slider.clientWidth - item.offsetWidth) / 2)),
        behavior: animate ? 'smooth' : 'auto',
      });

      window.clearTimeout(scrollSyncTimer);
      scrollSyncTimer = window.setTimeout(function () {
        suppressScrollSync = false;
      }, animate ? 420 : 80);
    }

    function renderMobile(animate) {
      items.forEach(function (item, index) {
        item.classList.remove('left', 'right', 'far-left', 'far-right');
        item.classList.toggle('center', index === current);
      });

      syncDots();
      syncButtons();
      scrollMobileToCurrent(animate);
    }

    function buildDots() {
      if (!dotsWrap) {
        return;
      }

      dotsWrap.innerHTML = '';

      if (items.length <= 4) {
        dotsWrap.style.display = 'none';
        return;
      }

      items.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.className = 'author-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Buch ' + (index + 1));
        dot.addEventListener('click', function () {
          current = index;
          if (isMobileMode()) {
            renderMobile(true);
          } else {
            render();
          }
        });
        dotsWrap.appendChild(dot);
      });
    }

    function render(animate) {
      if (isMobileMode()) {
        renderMobile(animate === true);
        return;
      }

      items.forEach(function (item, index) {
        item.classList.remove('center', 'left', 'right', 'far-left', 'far-right');

        if (items.length <= 4) {
          item.classList.add('center');
          return;
        }

        var diff = mod(index - current, items.length);
        if (diff === 0) item.classList.add('center');
        else if (diff === 1) item.classList.add('right');
        else if (diff === items.length - 1) item.classList.add('left');
        else if (diff === 2) item.classList.add('far-right');
        else if (diff === items.length - 2) item.classList.add('far-left');
      });

      syncDots();
      syncButtons();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        current = mod(current - 1, items.length);
        render(false);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        current = mod(current + 1, items.length);
        render(false);
      });
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function (event) {
        if (!isMobileMode() && items.length <= 4) {
          return;
        }

        if (index !== current) {
          event.preventDefault();
          current = index;
          if (isMobileMode()) {
            renderMobile(true);
          } else {
            render(false);
          }
        }
      });
    });

    slider.addEventListener('scroll', function () {
      if (!isMobileMode() || suppressScrollSync) {
        return;
      }

      window.clearTimeout(scrollSyncTimer);
      scrollSyncTimer = window.setTimeout(function () {
        var nextIndex = getCenteredIndex();
        if (nextIndex !== current) {
          current = nextIndex;
          items.forEach(function (item, index) {
            item.classList.toggle('center', index === current);
          });
        }
        syncDots();
      }, 120);
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.clearTimeout(scrollSyncTimer);
      scrollSyncTimer = window.setTimeout(function () {
        if (isMobileMode()) {
          renderMobile(false);
        } else {
          render(false);
        }
      }, 120);
    });

    buildDots();
    render(false);
  }

  function initBiography(root) {
    if (!root || root.dataset.authorBioInitialized === 'true') {
      return;
    }

    var wrap = root.querySelector('[data-bio-wrap]');
    var shell = root.querySelector('[data-bio-shell]');
    var content = root.querySelector('[data-bio-content]');
    var btn = root.querySelector('[data-bio-btn]');
    var fade = root.querySelector('[data-bio-fade]');

    if (!wrap || !shell || !content || !btn || !fade) {
      return;
    }

    root.dataset.authorBioInitialized = 'true';

    function getLineHeight() {
      var styles = window.getComputedStyle(content);
      var lineHeight = parseFloat(styles.lineHeight);

      if (Number.isNaN(lineHeight)) {
        lineHeight = parseFloat(styles.fontSize) * 1.78;
      }

      return lineHeight;
    }

    function getCollapsedHeight() {
      return Math.round(getLineHeight() * 4);
    }

    function getFullHeight() {
      return Math.ceil(content.scrollHeight);
    }

    var collapsedHeight = getCollapsedHeight();
    var fullHeight = getFullHeight();
    var expanded = false;
    var animating = false;
    var pendingClamp = false;

    if (fullHeight <= collapsedHeight + 6) {
      btn.style.display = 'none';
      fade.style.display = 'none';
      shell.classList.remove('is-collapsed');
      shell.style.height = 'auto';
      return;
    }

    shell.style.height = collapsedHeight + 'px';
    shell.classList.add('is-collapsed');

    function animateHeight(nextHeight) {
      shell.classList.add('is-animating');
      shell.style.height = shell.offsetHeight + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          shell.style.height = nextHeight + 'px';
        });
      });
    }

    btn.addEventListener('click', function () {
      if (animating) {
        return;
      }

      collapsedHeight = getCollapsedHeight();
      fullHeight = getFullHeight();
      animating = true;
      expanded = !expanded;

      if (expanded) {
        pendingClamp = false;
        shell.classList.remove('is-collapsed');
        wrap.classList.add('is-expanded');
        animateHeight(fullHeight);
      } else {
        shell.style.height = fullHeight + 'px';
        wrap.classList.remove('is-expanded');
        pendingClamp = true;
        animateHeight(collapsedHeight);
      }

      btn.textContent = expanded ? 'Weniger anzeigen' : 'Weiterlesen';
    });

    shell.addEventListener('transitionend', function (event) {
      if (event.propertyName !== 'height') {
        return;
      }

      animating = false;
      shell.classList.remove('is-animating');

      if (expanded) {
        shell.style.height = 'auto';
      } else if (pendingClamp) {
        pendingClamp = false;
        shell.classList.add('is-collapsed');
        shell.style.height = collapsedHeight + 'px';
      }
    });

    window.addEventListener('resize', function () {
      collapsedHeight = getCollapsedHeight();
      fullHeight = getFullHeight();

      if (fullHeight <= collapsedHeight + 6) {
        btn.style.display = 'none';
        fade.style.display = 'none';
        shell.classList.remove('is-collapsed');
        shell.classList.remove('is-animating');
        shell.style.height = 'auto';
        wrap.classList.add('is-expanded');
        return;
      }

      btn.style.display = '';
      fade.style.display = '';

      if (expanded) {
        shell.style.height = 'auto';
      } else {
        shell.classList.add('is-collapsed');
        shell.style.height = collapsedHeight + 'px';
      }
    });
  }

  function initAuthorSlider(root) {
    initSlider(root);
    initBiography(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-author-slider-root]');
    roots.forEach(initAuthorSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
